<template>
	<div>
		<div class="jinbu flex  align-items align-content">
			<div class="pointer" @click="shouye">首页</div>
			<div>/用户协议</div>
		</div>
	
	<div class="w1200" style="padding: 20px;">
		<div class="xieyi">注册协议</div>
		<div class="index8">
			<div class="content-h" v-html="detail.content"></div>
		</div>
	</div>
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				detail:''
			}
		},
		created() {
			this.post641568f1b6f87()
		},
		methods:{
			shouye(){
				this.$router.push({
					name: 'index',
				});
			},
			post641568f1b6f87(){
				this.$api.post(this.$apiUrls.post641568f1b6f87, {
					column_id: 1
				}).then((res) => {
					if (res.code == 1) {
						this.detail = res.data
					} else {
						this.$message.error(res.msg);
						return
					}
				})
			},
		},
	}
</script>

<style  lang="scss" scoped>
	.xieyi{
		font-weight: 900;
		font-size: 18px;
	}
	.content-h{
		height: 76vh;
		overflow-y: auto; 
	}
</style>